export const Scripts: ModdedBattleScriptsData = {
	inherit: 'gen7',
};
